import axios from 'axios';
import * as THREE from "three";

import { toast } from 'react-toastify';

import React, { useEffect, useState, useCallback } from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography'
import RadioGroup from '@material-ui/core/RadioGroup'
import SideStyle from '../style/sideStyle';
import { GreyRadio } from '../style/customUI';
import { loadSTLFile, loadPLYFile } from '../fileIO/fileLoader';

import Param from '../store/param';
import Control from '../store/control';
import ModalForPatientsFile from '../formBk/components/modalForPatientsFile';



const FormSetup = () => {

  const style = SideStyle();
  const param = Param.Get('setup');
  const setParam = Param.Get('setParam');

  const setControl = Control.Get('setControl');
  const prosthetics = Control.Get('prosthetics');
  const [pullModal, setPullModal] = useState(false)



  useEffect(() => {
    // active step
    setParam(s => { s.activestep = 0 })

    // 全てのパラメータをghni最初に全部送って初期化
    var obj = {}
    obj['f00'] = {}

    Object.keys(param).forEach(function (key) {
      obj['f00'][key] = param[key]
    });

  }, []);

  const handleValueScan = (e) => {
    loadPLYFile( e.target.files[0], (mesh) => {
      setControl(s => {s.meshLeg = mesh, s.redrawBox += 1}); // s.type = 'TestSocket',
      setControl(s => {s.showLeg = true})
    });
    console.log(e.target.files[0].name);
  }

  const handleValueScanSocket = (e) => {
    loadSTLFile( e.target.files[0], (mesh) => {
      setControl(s => {s.meshSocketLoad = mesh, s.redrawBox += 1}); // s.type = 'TestSocket',
    });
  }

  const handleValueInterface = (e) => {
    setParam(s => { s.setup.interface = Number(e.target.value) });
  };

  const handleValueSide = (e) => {
    setControl(s => { s.showMirror = Number(e.target.value) })
    //setParam(s => {s.setup.side = e.target.value});
    //setParam(s => {s.setup.side = 'L'});
  };


  return (
    <div className={style.outside}>
      <ModalForPatientsFile visible={pullModal} setVisible={setPullModal} onUpload={handleValueScanSocket} />
      <Grid container direction='row' justifyContent='center' alignItems='center' spacing={2}>
        {/*  socket data */}
        <Grid item xs={12} className={style.subcategory}>Socket data(.stl)</Grid>
        <Grid container direction='row' justifyContent='center' alignItems='center' xs={12} spacing={1}>
          <Grid item xs={5}>
            <Button
              component="label"
              className={style.button}
            >
              <input
                id='file'
                accept={[".stl"]}
                type="file"
                name='pathSocket'
                onChange={(e) => handleValueScanSocket(e)}
              />
            </Button>
          </Grid>
          {/* <Grid item xs={5}>
            <Button onClick={() => setPullModal(true)} className={[style.button]} style={{ padding: 4, fontSize: 13 }} component="label">
              Pull from DB
            </Button>
          </Grid> */}
        </Grid>

        {/* Leg data */}
        {(prosthetics == 'BK') &&
          <Grid item xs={12} className={style.subcategory}>Leg scan data(.ply)</Grid>
        }
        {(prosthetics == 'BK') &&
          <Grid item xs={8}>
            <Button
              component="label"
              className={style.button}
            >
              <input
                id='file'
                accept={[".ply"]}
                type="file"
                name='pathLeg'
                onChange={(e) => handleValueScan(e)}
              />
            </Button>
          </Grid>
        }
      </Grid>
    </div>
  );
}
export default FormSetup;
